/**
 * Normalize pilot line-item customizations for cart / POST /api/orders.
 * Checkbox groups from UI state are arrays; persisted shape uses `selections`
 * plus catalog metadata (matches Firestore / integration expectations).
 *
 * @param {Record<string, object>} productCustomizations - product API `customizations` schema
 * @param {Record<string, object|object[]>} selected - ProductDetail state (checkbox keys = arrays of options)
 * @returns {Record<string, object>}
 */
export function normalizePilotCustomizationsForOrder(
  productCustomizations,
  selected
) {
  if (!selected || typeof selected !== "object") return {};
  const defs = productCustomizations || {};
  const out = {};
  for (const [key, value] of Object.entries(selected)) {
    if (value === undefined || value === null) continue;
    const def = defs[key];
    if (def && def.uiType === "checkbox") {
      const selections = Array.isArray(value) ? [...value] : [value];
      if (selections.length === 0) continue;
      out[key] = {
        enabled: def.enabled !== false,
        displayName: def.displayName || key,
        description: def.description ?? "",
        sortOrder: def.sortOrder,
        required: def.required === true,
        uiType: "checkbox",
        selections,
      };
    } else {
      out[key] = value;
    }
  }
  return out;
}

/**
 * Coerce pre–selections-shape cart rows (bare checkbox arrays) before checkout.
 * Idempotent when `selections` is already present.
 *
 * @param {Record<string, unknown>} customizations
 * @returns {Record<string, unknown>}
 */
export function coerceLegacyPilotCartCustomizations(customizations) {
  if (!customizations || typeof customizations !== "object") return {};
  const out = { ...customizations };
  for (const [k, v] of Object.entries(out)) {
    if (
      Array.isArray(v) &&
      v.length > 0 &&
      v.every(
        (item) =>
          item &&
          typeof item === "object" &&
          !Array.isArray(item) &&
          (item.sku != null || item.id != null)
      )
    ) {
      out[k] = {
        displayName: String(k).replace(/_/g, " "),
        required: false,
        uiType: "checkbox",
        selections: v,
      };
    }
  }
  return out;
}
